import { Component } from "@angular/core";
import {
  NavigationService,
  NAVIGATION_CONST,
} from "../sk-services/navigation.service";

@Component({
  selector: "[sk-main-navigation]",
  templateUrl: "./main-nav.component.html",
  styleUrls: ["./main-nav.component.css"],
})
export class MainNavigationComponent {
  NAVIGATION_CONST: any = { ...NAVIGATION_CONST };
  constructor(private navigationService: NavigationService) {}

  onNavigationClick(navLink: string) {
    this.navigationService.navigationTo(navLink);
  }
}
